export default "__VITE_ASSET__Co0dz2Ae__"